<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Movimiento de Nómina</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="valor_abono"
            v-model="form.valor"
            vMoney
            :format="money"
            placeholder="Escriba un valor..."
          >
            $ Valor
            <span
              v-if="errores.valor"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.valor[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              @input="inputBodega"
              placeholder="Seleccione..."
              id="bodega_id"
              v-model="selectedBodega"
              :options="bodegas"
            ></v-select>
            <label for="bodega_id">Sucursal</label>
            <span
              v-if="errores.bodega_id"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.bodega_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <textarea-field
            placeholder="Escriba un detalle..."
            id="observacion"
            v-model="form.detalle"
          >
            <span>Detalle</span>
            <span
              v-if="errores.detalle"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.detalle[0] }}</strong>
            </span>
          </textarea-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              @input="inputTipoMovimiento"
              placeholder="Seleccione..."
              id="tipo_movimiento_id"
              v-model="selectedTipoMovimiento"
              :options="tiposMovimiento"
            ></v-select>
            <label for="tipo_movimiento_id">Tipo de movimiento</label>
            <span
              v-if="errores.tipo_movimiento_id"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.tipo_movimiento_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div v-show="selectedTipoMovimiento != null && selectedTipoMovimiento.tipo_aplicacion !== 'V'" class="col-xs-12 col-md-6">
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              placeholder="Seleccione..."
              :options="personas"
              id="persona"
              name="persona"
              @input="inputPersona"
              v-model="selectedPersona"
              @search="searchPersonas"
              label="nombre"
            ></v-select>
            <label for="persona">Personas</label>
            <span
              v-if="errores.persona_id"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.persona_id[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div v-show="selectedTipoMovimiento != null && selectedTipoMovimiento.tipo_aplicacion === 'V'" class="col-xs-12 col-md-6">
        <div
          class="form-field select2"
        >
          <div class="select2-field">
            <v-select
              @search="searchVendedores"
              @input="inputVendedor"
              v-model="selectedVendedor"
              :options="vendedores"
              placeholder="Seleccione..."
              label="descripcion"
              id="vendedor"
            ></v-select>
            <label for="vendedor">Vendedor</label>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <VueCtkDateTimePicker
              id="fecha"
              v-model="form.fecha"
              locale="es"
              no-label
              button-now-translation="Ahora"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="YYYY-MM-DD HH:mm:ss"
              label="Seleccione fecha..."
              
            />
            <label>Fecha</label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success">
        <i class="fa fa-save"></i><span>Guardar</span>
      </button>
      <button @click="cancelar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    tiposMovimiento: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    value: {
      type: Object,
      required: false,
      default: function () {
        return {
          valor: "",
          detalle: "",
          bodega_id: "",
          tipo_movimiento_id: "",
          fecha: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
          vendedor_id: '',
          persona_id: ''
        };
      },
    },
  },
  data: function () {
    return {
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      selectedBodega: null,
      selectedTipoMovimiento: null,
      money: money,
      personas: [],
      selectedPersona: null,
      selectedVendedor: null,
      vendedores: []
    };
  },
  methods: {
    inputVendedor: function () {
      if (this.selectedVendedor != null)
        this.form.vendedor_id = this.selectedVendedor.id;
      else 
        this.form.vendedor_id = '';
    },
    searchVendedores: function (search, loading) {
      loading(true);
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function () {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
          let json = JSON.parse(this.responseText);
          that.vendedores = json;
          loading(false);
        } else loading(false);
      };
      xmlhttp.open("GET", url + "/search/vendedores?search=" + search, true);
      xmlhttp.send();
    },
    searchPersonas: function (search, loading) {
      if (this.selectedTipoMovimiento != null) {
        loading(true);
        let that = this;
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
          if (
            (this.readyState == 4 && this.status == 200) ||
            this.status == 201
          ) {
            let json = JSON.parse(this.responseText);
            that.personas = json;
            loading(false);
          } else loading(false);
        };
        xmlhttp.open(
          "GET",
          url + "/search/usuarios?tipo=" + this.selectedTipoMovimiento.tipo_aplicacion + "&search=" + search,
          true
        );
        xmlhttp.send();
      }
    },
    inputPersona: function () {
      if (this.selectedPersona != null) {
        this.form.persona_id = this.selectedPersona.id;
      }
      else 
        this.form.persona_id = '';
    },
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    inputTipoMovimiento: function () {
      if (this.selectedTipoMovimiento != null)
      {
        this.form.tipo_movimiento_id = this.selectedTipoMovimiento.codigo;
        if (this.selectedTipoMovimiento.tipo_aplicacion === 'V') {
          this.selectedPersona = null;
          this.form.persona_id = '';
        }
        else {
          this.selectedVendedor = null;
          this.form.vendedor_id = '';
        }
      }
      else this.form.tipo_movimiento_id = "";
    },
    guardar: function () {
      swal({
        title: "¿Desea almacenar los datos del movimiento?",
        text: "Se requiere confirmación",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let urlRequest = url + "/movimientos-nomina";
          axios
            .post(urlRequest, this.form)
            .then(() => {
              swal(
                "El movimiento fue almacenado exitósamente.",
                "Realizado",
                "success"
              );
              this.$emit("saved");
            })
            .catch(({ response }) => {
              let status = response.status;
              if (status == 422) {
                this.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            });
        }
      });
    },
    cancelar: function () {
      this.$emit("cancelar");
    },
  },
  mounted: function () {
    if (this.bodegas.length === 1) {
      this.selectedBodega = this.bodegas[0];
      this.inputBodega();
    }
    if (this.tiposMovimiento.length === 1) {
      this.selectedTipoMovimiento = this.tiposMovimiento[0];
      this.inputTipoMovimiento();
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/nomina/Movimiento.vue